import { render, staticRenderFns } from "./PUserPicEdit.vue?vue&type=template&id=54db3bea&"
import script from "./PUserPicEdit.vue?vue&type=script&lang=ts&"
export * from "./PUserPicEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports